// Components
import { PageHeader } from "../components/PageSpecificComponents";

// Containers
import AddBranchFrom from "../containers/forms/manageBranches/addBranch/AddBranch.form";

// Styles
import { AddBranchStyles } from "../pagesStyles/addBranch.styles";

const AddBranch = () => {
  return (
    <AddBranchStyles>
      <PageHeader title="Add New Branch" showBack />
      <AddBranchFrom />
    </AddBranchStyles>
  );
};

export default AddBranch;
